import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useTranslation } from '@ibk/shared-translation';
import { RadioButton } from '@ibk/shared-ui';
import styles from './EmissorRechargeReportDrawer.module.css';
const RADIO_GROUP_NAME = 'emissor-recharge-report-modality';
const MODALITY_OPTIONS = [
    {
        value: 'orders',
        titleKey: 'benefits.orders.recharge-report.modality.by-order.title',
        descriptionKey: 'benefits.orders.recharge-report.modality.by-order.description',
        testId: 'radioReportModalityStepByOrder',
    },
    {
        value: 'beneficiaries',
        titleKey: 'benefits.orders.recharge-report.modality.by-cpf.title',
        descriptionKey: 'benefits.orders.recharge-report.modality.by-cpf.description',
        testId: 'radioReportModalityStepByCpf',
    },
];
export function ReportModalityStep({ modality, onSelect }) {
    const { t } = useTranslation();
    return (_jsxs("div", { className: styles.stepContent, "data-testid": 'viewReportModalityStep', children: [_jsx("p", { className: styles.stepHint, children: t('benefits.orders.recharge-report.modality.hint') }), _jsx("div", { className: styles.modalityList, children: MODALITY_OPTIONS.map(option => (_jsxs(RadioButton, { id: option.testId, name: RADIO_GROUP_NAME, value: option.value, checked: modality === option.value, onChange: value => onSelect(value), className: styles.modalityCard, "data-testid": option.testId, children: [_jsx("span", { className: styles.modalityTitle, children: t(option.titleKey) }), _jsx("span", { className: styles.modalityDescription, children: t(option.descriptionKey) })] }, option.value))) })] }));
}
